/* -------------------------------------------------------------
■以下、ローンシミュレーションのメイン関数
※これ以降の設定は不要です。
------------------------------------------------------------- */
$(function () {
	$('#result-area').hide();
	$('#reset').click(function () {
		$('#result-area').hide();
	});

	$('#pagetop_scroll').click(function(){
		scrollPagetop();
	});

	$('#total, #bonus_plus')
		.focusin(function(e) {
			// 入力項目のカンマ削除
			delComma($(this));
	    })
		.focusout(function(e) {
			// 入力項目のカンマ編集
			insertComma($(this));
		});
});

function scrollPagetop() {
	var position = $('#pagetop').offset().top;
	$("html,body").animate({
		scrollTop : position
	}, {
		queue : false
	});
}
function scrollResult() {
	var position = $('#result-area').offset().top;
	$("html,body").animate({
		scrollTop : position
	}, {
		queue : false
	});
}

var UNIT = 1000000000 ;
var DELIMITER = new String( '<>' ) ;
var INPUT_FORM_NAME = "g_buy_form" ;
var INPUT_FORM_BONUS_NAME = "bonus_plus" ;

var errorFlag = false ;
var errorMsg  = new Array( ) ;

// =============================================================
// テーブルのレイアウトを管理するクラス
function Headline( headline )
{
	this.headline = headline ;
}

function Headline2( headline )
{
	this.headline = headline ;
}

Headline.prototype.getHeadline = getHeadline_ ;
Headline2.prototype.getHeadline = getHeadline_ ;

function getHeadline_( )
{
	return this.headline ;
}

Headline.prototype.getTableData = function( )
{
	return '<th align="center">' +this.getHeadline( )+ '</th>' ;
}

Headline2.prototype.getTableData = function( )
{
	if ( !LoanSimulation.RATE_VISIBILITY ) return '' ;

	return '<th align="center">' +this.getHeadline( )+ '</th>' ;
}
// ============================================================= 



// =============================================================
// 「支払回数」と「分割払手数料」を管理するクラス
function LoanSimulation( pay_times, charge_rate )
{
	this.pay_times   = pay_times ;
	this.charge_rate = charge_rate ;
}

LoanSimulation.prototype.getPayTimes = function( )
{
	return this.pay_times ;
}

LoanSimulation.prototype.getChargeRate = function( )
{
	return this.charge_rate ;
}

LoanSimulation.prototype.getData = function( )
{
	var buy_form = document.forms[ INPUT_FORM_NAME ] ;

	errorFlag = false ;
	errorMsg  = new Array( ) ;

	// ローン対象額 (a)
	var buy_total1 = parseInt( delComma2(buy_form.total1.value) ) ;
	var buy_tax = 0;
	var buy_total2 = buy_total1 + buy_tax ;

	// ボーナス月加算額 (b_1)
	var bonus_plus = 0 ;

	// ボーナス月加算月 (b_2)
	// var bonus_month = getSelectValue( buy_form, "bonus_month" ) ;

	// 分割払手数料 (c)
	var pay_charge_rate = this.getChargeRate( ) ;

	// お客様ご負担手数料 (d)
	// ※データ結果を合わせるために、小数点第9位から四捨五入する
	var pay_charge = ( Math.round( buy_total2 * pay_charge_rate / 100 ) * UNIT ) / UNIT ;

	// 支払い総額 (e)
	var total_amount = pay_charge + buy_total2;

	// お支払い回数 (n)
	var pay_times = this.getPayTimes( ) ;

	if ( getSelectValue( buy_form, "bonus_heiyo" ) == "yes" )
	{
		// ボーナス回数
		if ( isNaN( parseInt( pay_times / 6 ) ) )
		{
			bonus_times = 0;
			bonus_plus = 0;
		}
		else
		{
			bonus_times = parseInt( pay_times / 6 );
			bonus_plus  = delComma2(buy_form.bonus_plus.value) ;
		}
	}
	else
	{
		// ボーナス払い無しの場合
		bonus_plus = 0;
		bonus_times = 0;
	}

	// ボーナス払いに関しては「ボーナス支払い金額　×　回数」というフォーマットで書き出す
	var bonus_return_value = insertComma2( new String( bonus_plus ) ) + ' × ' + setSpacer( bonus_times, 2 ) + bonus_times ;

	// 2回目以降の月々の支払額 (g)
	var pay_month = parseInt(((total_amount - ( bonus_plus * bonus_times ) ) / pay_times) / 100) * 100 ;

	// 2回目以降の支払い回数
	var pay_month_times = pay_times - 1;

	// 初回支払い額 (f)
	var pay_first = total_amount - ( bonus_plus * bonus_times ) - ( pay_month * pay_month_times ) ;

	if ( pay_month < MIN_PAY_MONTH )
	{
		errorFlag = true ;
		if ( MIN_PAY_MONTH_ALERT ) 
		{
			errorMsg[ errorMsg.length ] = "月々の返済金は" + MIN_PAY_MONTH + "円以上で計算しています" ;
		}
	}

	if ( bonus_plus * bonus_times > total_amount / 2 )
	{
		errorFlag = true ;
		errorMsg[ errorMsg.length ] = "ボーナス加算返済額の合計はローン対象額の2分の1以内でお願いします" ;
	}

	if ( errorFlag )
	{
		return setArguments( pay_times, '-', '-', '-', '-', '-', '-' ) ;
	}

	return setArguments( 
				pay_times, 										// 分割回数
				insertComma2( new String( pay_charge ) ), 		// 手数料
				LoanSimulation.NENRITSU + "%", 					// 実質年率
				insertComma2( new String( total_amount ) ),		// 支払総額
				insertComma2( new String( pay_first ) ), 		// 1回目
				insertComma2( new String( pay_month ) ), 		// 2回目以降
				bonus_return_value								// ボーナス加算額
	) ;
}
// =============================================================


// 全体を統括するメイン関数
function process( )
{
	var buy_form = document.forms[ INPUT_FORM_NAME ] ;
	var tableData = new String( '' ) ;
	var layerObj = document.getElementById('result');
	var errorLog = new String( '' ) ;

	// まずは必須項目の確認
	if ( !validateInput( buy_form ) )
	{
		$('#result-area').hide();
		return ;
	}

	tableData = getTableData( 'create' ) ;

	if ( errorFlag )
	{
		for ( var i=0; i<errorMsg.length; i++ )
		{
			errorLog += errorMsg[ i ] +'\n' ;
		}

		if ( errorLog != "")
		{
			alert( errorLog ) ;
		}
	}

	layerObj.innerHTML = tableData;
	$('#result-area').show();
	scrollResult();
}

// 必須項目チェック
function validateInput( fm )
{

	var total = delComma2(fm.total1.value);
	var bonus_plus = delComma2(fm.bonus_plus.value);

	// 「ローン対象額」の未入力はダメ
	if( total == "" )
	{
		alert( "ローン対象額を必ず入力してください。" ) ;
		fm.total1.focus( ) ;
		return false ;
	}

	// 「ローン対象額」は必ず数字で
	if( isNaN( parseInt( total ) ) )
	{
		alert( "ローン対象額は数字でなくてはいけません。" ) ;
		fm.total1.focus( ) ;
		return false ;
	}

	// ボーナス併用の時
	if( getSelectValue( fm, "bonus_heiyo" ) == "yes" )
	{
		// 「ボーナス加算額」の未入力はダメ
		if( bonus_plus == "" )
		{
			alert( "ボーナス加算額を必ず入力してください。" ) ;
			fm.bonus_plus.focus( ) ;
			return false ;
		}

		// 「ボーナス加算額」は必ず数字で
		if( isNaN( parseInt( bonus_plus ) ) )
		{
			alert( "ボーナス加算額は数字でなくてはいけません。" ) ;
			fm.bonus_plus.focus( ) ;
			return false ;
		}
	}

	return true ;
}

function getTableData( mode )
{
	var stringBuffer = new String( "" ) ;
	var temp = new String( '' ) ;

	stringBuffer += '<table class="result_tbl">' ;

	stringBuffer += createHeader( ) ;

	if ( mode == "create" )
	{
		for ( var i=0; i<ENTRY.length; i++ )
		{
			if ( ENTRY[ i ].getPayTimes( ) > LoanSimulation.MAX_OF_PAY_TIMES )
			{
				break ;
			}

			temp = "" ;
			temp = ENTRY[ i ].getData( ) ;
			stringBuffer += getTableTd( temp ) ;
		}
	}
	else
	{
		for ( var i=0; i<ENTRY.length; i++ )
		{
			if ( ENTRY[ i ].getPayTimes( ) > LoanSimulation.MAX_OF_PAY_TIMES )
			{
				break ;
			}

			temp = "" ;
			temp = setArguments( ENTRY[ i ].getPayTimes( ), '0', '0', '0', '0', '0', '0 × &nbsp;0' )  ;
			stringBuffer += getTableTd( temp ) ;
		}
	}

	stringBuffer += '</table> ' ;

	return stringBuffer.toString( ) ;
}


function getTableTd( )
{
	var table_td_data = arguments[ 0 ].split( DELIMITER ) ;
	var stringBuffer  = new String( '' ) ;
	var bonus_heiyo = $('#bonus_heiyo').val();

	stringBuffer = '<tr>' ;

	for ( var i=0; i<table_td_data.length; i++ )
	{
		// 「実質年率」を非表示にする設定で、且つ、引き数が「実質年率」にあたるとき、未処理とする
		if ( !LoanSimulation.RATE_VISIBILITY && i== 2 )
		{
			continue ;
		}

		// 「ボーナス加算」がなしの場合、「ボーナス加算額」を非表示にする
		if (bonus_heiyo == "no" && i==6) {
			continue ;
		}

		stringBuffer += '<td align="right">' +table_td_data[ i ]+ '</td>\n' ;
	}

	stringBuffer += '</tr>' ;

	return stringBuffer.toString( ) ;
}


function setArguments( )
{
	var stringBuffer = new String( '' ) ;

	for ( var i=0; i<arguments.length-1; i++ )
	{
		stringBuffer += arguments[ i ] + DELIMITER ;
	}

	stringBuffer += arguments[ arguments.length-1 ] ;

	return stringBuffer.toString( ) ;
}


function createHeader( )
{
	var stringBuffer = new String( '' ) ;
	var bonus_heiyo = $('#bonus_heiyo').val();

	for ( var i=0; i<RESULT_TABLE.length; i++ )
	{
		// 「ボーナス加算」がなしの場合、「ボーナス加算額」を非表示にする
		if (bonus_heiyo == "no" && LoanSimulation.RATE_VISIBILITY && i==6) {
			continue;
		}

		stringBuffer += RESULT_TABLE[ i ].getTableData( ) ;
	}

	return stringBuffer ;
}


function setSpacer( num, max )
{
	var spacer = new String( '' ) ;
	var temp = num.toString( )

	for ( var i=temp.length; i<=max; i++ )
	{
		spacer += '&nbsp; ' ;
	}

	return spacer ;
}


function resetForm( )
{
	var buy_form = document.forms[ INPUT_FORM_NAME ] ;

	buy_form.reset( ) ;

	init( ) ;

	clearTable( ) ;
}


// すべての関数の初期化を行う
function init( )
{
	var buy_form = document.forms[ INPUT_FORM_NAME ] ;

	// ローン対象額にフォーカスを与える
	buy_form[ 0 ].focus( ) ;

	if (getSelectValue( buy_form, "bonus_heiyo" ) == "no") {
		// ボーナス加算額のテキストボックスの入力を出来なくする
		buy_form[ INPUT_FORM_BONUS_NAME ].value = "" ;
		buy_form[ INPUT_FORM_BONUS_NAME ].disabled = true ;
	}

	clearTable( ) ;
}

function clearTable( )
{
	var layerObj = document.getElementById('result');
	var tableData = null ;

	// 「initialize」モードでテーブルのデータを取得する
	tableData = getTableData( 'initialize' ) ;

	// 取得したテーブルのノードでレイヤーを書き換える
	layerObj.innerHTML = tableData;
}

window.onload = init ;

/* -------------------------------------------------------------
■入力制限を行う関数
※設定不要です。
------------------------------------------------------------- */

// =============================================================

function readToggle( )
{
	var buy_form = document.forms[ INPUT_FORM_NAME ] ;

	if (getSelectValue( buy_form, "bonus_heiyo" ) == "no") {
		// ボーナス加算額のテキストボックスの入力を出来なくする
		buy_form[ INPUT_FORM_BONUS_NAME ].value = "" ;
		buy_form[ INPUT_FORM_BONUS_NAME ].disabled = true ;
	} else {
		// ボーナス加算額のテキストボックスの入力を可能にする
		buy_form[ INPUT_FORM_BONUS_NAME ].disabled = false ;
	}
}

/* -------------------------------------------------------------
■３桁カンマ挿入関数　/削除関数 
※(Subject: [js-ml:05272])
 ------------------------------------------------------------- */
function insertCommaAll() {
	insertComma($("#total"));
	insertComma($("#bonus_plus"));
}
function delCommaAll() {
	delComma($("#total"));
	delComma($("#bonus_plus"));
}
function insertComma(obj) {
	var temp = insertComma2(obj.val());
	obj.val(temp);
}
function delComma(obj) {
	var temp = delComma2(obj.val());
	obj.val(temp);
}
function insertComma2( str )
{
	if ( str=="" || str==null || escape( str )=="%20" ) return "" ;

	var temp1  = str ;

	if ( isNaN( temp1 ) )
	{
		return str ;
	}

	temp1 = parseInt(temp1.split(".")[0],10) ;
	temp1 = "" + Math.abs(temp1) ;
	temp1 = temp1.match(/./g).reverse().join("") ;
	temp1 = temp1.replace(/(\d{3})/g,"$1,") ;
	temp1 = temp1.match(/./g).reverse().join("").replace(/^,/,"") ;

	if (str.charAt(0)=='-') temp1 = "-" + temp1 ;
	if(!!str.split(".")[1])temp1 = temp1 +"."+ str.split(".")[1] ;

	return temp1 ;
}

function delComma2( w )
{
	return w.split(",").join("") ;
}

/* -------------------------------------------------------------

■スワップイメージ用関数
※設定不要です。

------------------------------------------------------------- */

var preloadFlag  = false ;

// セレクトボックスの値を取得
function getSelectValue( form, index )
{
	var element = form.elements[ index ] ;
	if( element != null )
	{
		return element.options[ element.selectedIndex ].value ;
	}
	return "" ;
}

// ラジオボタンの値を取得
function getRadioValue( form, index )
{
	var element = form.elements[ index ] ;
	for( var i=0; i < element.length; i++ )
	{
		if( element[ i ].checked )
		{
			return element[ i ].value ;
		}
	}
	return "" ;
}

/* -------------------------------------------------------------
■結果テーブルの見出しを設定
※「実質年数」のみ、Headline2 クラスを使用
例）RESULT_TABLE[ RESULT_TABLE.length ] = new Headline( '見出し' ) ;
------------------------------------------------------------- */
var RESULT_TABLE = new Array( ) ;
RESULT_TABLE[ RESULT_TABLE.length ] = new Headline( '分割回数' ) ;
RESULT_TABLE[ RESULT_TABLE.length ] = new Headline( '手数料' ) ;
RESULT_TABLE[ RESULT_TABLE.length ] = new Headline2( '実質年率' ) ;
RESULT_TABLE[ RESULT_TABLE.length ] = new Headline( '支払総額' ) ;
RESULT_TABLE[ RESULT_TABLE.length ] = new Headline( '1回目' ) ;
RESULT_TABLE[ RESULT_TABLE.length ] = new Headline( '2回目以降' ) ;
RESULT_TABLE[ RESULT_TABLE.length ] = new Headline( 'ボーナス加算額' ) ;
